import { render, staticRenderFns } from "./DashboardVendedor.vue?vue&type=template&id=5de4c549&scoped=true&"
import script from "./DashboardVendedor.vue?vue&type=script&lang=js&"
export * from "./DashboardVendedor.vue?vue&type=script&lang=js&"
import style0 from "./DashboardVendedor.vue?vue&type=style&index=0&id=5de4c549&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de4c549",
  null
  
)

export default component.exports